import React, { Component } from 'react';
import Mainpage from '../../shared-components/src/containers/Mainpage/Mainpage';
import styles from './App.css';

class App extends Component {
  render () {
    return (
      <div>
        <Mainpage />
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js